import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getProjectInsights } from "@/app/actions/project/get-insights/action";
import { CallScopeFilter } from "@/app/types/call/CallScopeFilter";
import { UCallScope } from "@/app/utils/UCallScope";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectInsights(
  projectId?: number,
  offerId?: number,
  filter: CallScopeFilter = {},
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: [
      QueryKey.PROJECT_INSIGHTS,
      projectId,
      offerId ?? null,
      ...UCallScope.queryKey(filter),
    ],
    queryFn: () => {
      if (!projectId) return null;
      return getProjectInsights(projectId, offerId, filter);
    },
    enabled: enabled && !!projectId,
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  });
}
